import {createSaveRequestKey} from './requestKey';
import {readSessionKey} from './queryCache';
import {ECOMMERCE_API_BASE_URL} from '../config';

export type ImportTaskRecord={id:string;scope:string;owner?:string;kind:string;entry:string;props:Record<string,unknown>;state:Record<string,any>;route:string;updated:number};
export type ImportUploadCheckpoint={ticket:string;offset:number;chunkSize:number;started:number};
const fileOwners=new WeakMap<File,string>();
const checkpoints=new WeakMap<File,ImportUploadCheckpoint>();
const database='withpot-batch-imports-v1';
async function db():Promise<IDBDatabase>{return new Promise((resolve,reject)=>{
    const request=indexedDB.open(database,1);
    request.onupgradeneeded=()=>{request.result.createObjectStore('tasks',{keyPath:'id'});request.result.createObjectStore('files');request.result.createObjectStore('uploads');};
    request.onsuccess=()=>{request.result.onversionchange=()=>request.result.close();resolve(request.result);};
    request.onerror=()=>reject(new Error('无法保存上传任务，请检查本机存储'));
    request.onblocked=()=>reject(new Error('本机存储未就绪，请关闭旧页面后重试'));
});}
async function transaction<T>(stores:string[],mode:IDBTransactionMode,work:(tx:IDBTransaction,result:(value:T)=>void)=>void):Promise<T>{
    const connection=await db();return new Promise((resolve,reject)=>{
        const tx=connection.transaction(stores,mode);let value:T;
        tx.oncomplete=()=>{connection.close();resolve(value);};
        tx.onerror=tx.onabort=()=>{connection.close();reject(new Error('上传任务未保存，请检查本机存储'));};
        try{work(tx,next=>{value=next;});}catch(error){tx.abort();reject(error);}
    });
}
export function importTabId(){
    const key='withpot-import-tab';let id=sessionStorage.getItem(key);if(!id){id=createSaveRequestKey();sessionStorage.setItem(key,id);}return id;
}
export async function importTaskScope(){
    const bytes=new TextEncoder().encode(`${ECOMMERCE_API_BASE_URL}|${readSessionKey()}`);
    return Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',bytes)),byte=>byte.toString(16).padStart(2,'0')).join('');
}
export function bindImportFile(file:File,id:string){fileOwners.set(file,id);}
export function getImportCheckpoint(file:File){return checkpoints.get(file);}
export async function saveImportCheckpoint(file:File,value:ImportUploadCheckpoint){
    const saved={ticket:value.ticket,offset:value.offset,chunkSize:value.chunkSize,started:value.started};
    checkpoints.set(file,saved);const id=fileOwners.get(file);if(!id)return;
    await transaction<void>(['uploads'],'readwrite',(tx,result)=>{tx.objectStore('uploads').put(saved,id);result();});
}
export async function saveImportTask(record:ImportTaskRecord,fileChanged=false){
    const {file,...state}=record.state;
    await transaction<void>(['tasks','files','uploads'],'readwrite',(tx,result)=>{
        tx.objectStore('tasks').put({...record,state,updated:Date.now()});
        if(fileChanged){if(file){tx.objectStore('files').put(file,record.id);bindImportFile(file,record.id);}else tx.objectStore('files').delete(record.id);tx.objectStore('uploads').delete(record.id);}
        result();
    });
}
export async function loadImportTasks(scope:string,includeUnowned=false):Promise<ImportTaskRecord[]>{
    return transaction(['tasks','files','uploads'],'readonly',(tx,result)=>{
        const request=tx.objectStore('tasks').getAll();request.onsuccess=()=>{
            const records=(request.result as ImportTaskRecord[]).filter(record=>record.scope===scope&&(record.owner===importTabId()||(includeUnowned&&!record.owner)));
            for(const record of records){const file=tx.objectStore('files').get(record.id),upload=tx.objectStore('uploads').get(record.id);let checkpoint:ImportUploadCheckpoint|undefined;
                file.onsuccess=()=>{if(file.result){const restored=file.result as File;record.state.file=restored;bindImportFile(restored,record.id);if(checkpoint)checkpoints.set(restored,checkpoint);}};
                upload.onsuccess=()=>{checkpoint=upload.result;if(record.state.file&&checkpoint)checkpoints.set(record.state.file,checkpoint);};
            }
            result(records);
        };
    });
}
export async function deleteImportTask(id:string){await transaction<void>(['tasks','files','uploads'],'readwrite',(tx,result)=>{for(const store of ['tasks','files','uploads'])tx.objectStore(store).delete(id);result();});}
